// eslint-disable-next-line import/no-extraneous-dependencies
import { createPopper } from '@popperjs/core'

const instanceMap = new WeakMap()

export default {
  mounted(el, binding) {
    const options =
      typeof binding.value === 'object'
        ? binding.value
        : { content: String(binding.value) }

    const trigger = options.trigger || 'click'
    let offsetX = options.offsetX || 0;
    const offsetY = options.offsetY || 12
    const width = options.width || 'auto';
    const placement = options.placement || 'bottom'
    if (placement.includes("start")) {
      offsetX = options.offsetX || -15;
    }
    if (placement.includes("end")) {
      offsetX = options.offsetX || 6;
    }
    // create popover
    const popover = document.createElement('div')
    popover.className = `custom-popper ${options.className || ''}`
    if(trigger === 'hover') {
      popover.className += 'tooltip-hover'
    }
    popover.style.width = width;
    if (options.maxWidth) {
      popover.style.maxWidth = options.maxWidth;
    }
    if (options.minWidth) {
      popover.style.minWidth = options.minWidth;
    }
    popover.style.display = 'none'
    document.body.appendChild(popover)

    const state = {
      options,
      popover,
      popperInstance: null,
      toggleHandler: null,
      hideHandler: null,
      clickHandler: null,
    }

    const setContent = () => {
      const content =
        typeof state.options.content === 'function'
          ? state.options.content()
          : state.options.content || ''
      state.popover.innerHTML = content
    }

    const popperInstance = createPopper(el, popover, {
      strategy: 'fixed',
      placement,
      modifiers: [
        { name: 'offset', options: { offset: [offsetX, offsetY] } },
        { name: 'preventOverflow', enabled: false },
        { name: 'computeStyles', options: { adaptive: false, gpuAcceleration: false } },
        { name: 'flip', options: { fallbackPlacements: [] } }, // disable flip
      ]
    })
    state.popperInstance = popperInstance
    const show = () => {
      if (state.options.disabled && trigger === 'hover') return
      setContent()
      state.popover.style.display = 'block'
      state.popperInstance.update()
    }

    const hide = () => {
      state.popover.style.display = 'none';
      if (state.options.onHide) state.options.onHide()
    }
    const toggle = (e) => {
      if (state.options.disabled && trigger === 'hover') return
      e.stopPropagation()
      if (state.popover.style.display === 'none') {
        setContent()
        state.popover.style.display = 'block'
        state.popperInstance.update()
        if (state.options.onShow) state.options.onShow()
      } else {
        hide()
      }
    }
      if (trigger === 'hover') {
        el.addEventListener('mouseenter', show)
        el.addEventListener('mouseleave', hide)
        // Keep tooltip visible when hovering over it
          popover.addEventListener('mouseenter', () => {
            popover.style.display = 'block'
          })
          popover.addEventListener('mouseleave', hide)
      } else {
        el.addEventListener(trigger, toggle)
      }
      const hideOnClickOutside = (e) => {
        const instance = instanceMap.get(el)
        if (!instance) return

        if (
          instance.popover &&
          !instance.popover.contains(e.target) &&
          !el.contains(e.target)
        ) {
          hide()
        }
      }
     instanceMap.set(el, state)
     const handleClick = (e) => {
        if (options.onClick) {
          const args = e.target.dataset.clickargs ? JSON.parse(e.target.dataset.clickargs) : null
          if(args) {
            options.onClick.apply(null, Object.values(args));
          }else options.onClick();  // Call the component's viewRegistration method
        }
      }
      popover.addEventListener('mousedown', (e) => {
        e.stopPropagation()
      })
      popover.addEventListener('click', handleClick)
      // Store the handler for cleanup
      instanceMap.get(el).clickHandler = handleClick 

    document.addEventListener('mousedown', hideOnClickOutside)

  },

  updated(el, binding) {
    const options =
      typeof binding.value === 'object'
        ? binding.value
        : { content: String(binding.value) }

    const instance = instanceMap.get(el)
    if (instance) {
      // update to latest incoming options
      instance.options = options

      const content =
        typeof options.content === 'function'
          ? options.content()
          : options.content || ''
      instance.popover.innerHTML = content
      if (instance.popperInstance) instance.popperInstance.update()
    }
  },

  unmounted(el) {
    const instance = instanceMap.get(el)
    if (instance) {
      instance.popover.remove()
      instance.popperInstance.destroy()
      el.removeEventListener('click', instance.toggleHandler)
      document.removeEventListener('click', instance.hideHandler)
      if (instance.clickHandler) {
        instance.popover.removeEventListener('click', instance.clickHandler)
      }
      instanceMap.delete(el)
    }
  }
}